import { useGrafStore } from '../../../store/useGrafStore'

export function ChartFormatPicker({ useStore = useGrafStore }) {
  const { chartFormat, setChartFormat, interactive, setInteractive } = useStore()

  return (
    <div className="flex flex-col gap-1">
      <span className="text-xs text-gray-400 font-medium uppercase tracking-wide">Formát</span>
      <div className="flex items-center gap-3">
        {['png', 'jpg', 'svg'].map(fmt => (
          <label key={fmt} className="flex items-center gap-1 text-xs text-gray-600 cursor-pointer">
            <input
              type="radio"
              name="chartFormat"
              checked={chartFormat === fmt}
              onChange={() => setChartFormat(fmt)}
              className="accent-blue-600"
            />
            {fmt.toUpperCase()}
          </label>
        ))}
        <label className="flex items-center gap-1.5 text-xs text-gray-600 cursor-pointer ml-2 border-l pl-3 border-gray-200">
          <input
            type="checkbox"
            checked={interactive}
            onChange={e => setInteractive(e.target.checked)}
            className="accent-blue-600"
          />
          Interaktivní
        </label>
      </div>
    </div>
  )
}
